import chooseNextProperId from 'helpers/chooseNextProperId'

export default function prepEntities(m) {
  const entities = m.filter(m => m.hasOwnProperty('id'))
  const validEntities = entities.filter(m => m.id > 0)
  const entitiesWithNoId = entities.filter(m => !m.id)

  return [
    ...validEntities,
    ...entitiesWithNoId
      .map((m, i) => (
        {
          ...m,
          id: chooseNextProperId(validEntities.map(m => m.id)) + i }
      ))
  ]
}



// WEBPACK FOOTER //
// ./src/helpers/map/prepEntities.js